var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgScroll(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 6.1875H9.375V2.4375C9.375 1.57812 8.67188 0.875 7.8125 0.875H1.5625C0.683594 0.875 0 1.57812 0 2.4375V3.375C0 3.90234 0.410156 4.3125 0.9375 4.3125H1.5625V3.375H0.9375V2.4375C0.9375 2.10547 1.21094 1.8125 1.5625 1.8125C1.89453 1.8125 2.1875 2.10547 2.1875 2.4375V8.0625C2.1875 8.94141 2.87109 9.625 3.75 9.625H8.94531C10.2148 9.625 11.25 8.60938 11.25 7.33984V7.125C11.25 6.61719 10.8203 6.1875 10.3125 6.1875ZM4.375 6.8125V8.0625C4.375 8.41406 4.08203 8.6875 3.75 8.6875C3.39844 8.6875 3.125 8.41406 3.125 8.0625V2.4375C3.125 2.22266 3.06641 2.00781 2.98828 1.8125H7.8125C8.14453 1.8125 8.4375 2.10547 8.4375 2.4375V6.1875H5C4.64844 6.1875 4.375 6.48047 4.375 6.8125ZM10.3125 7.33984C10.3125 8.08203 9.6875 8.6875 8.94531 8.6875H5.17578C5.25391 8.51172 5.3125 8.29688 5.3125 8.0625V7.125H10.3125V7.33984Z",
    fill: "#A4ADB6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgScroll);
export default __webpack_public_path__ + "static/media/img_scroll.68ff2a41b088344a666543d4a0edacb0.svg";
export { ForwardRef as ReactComponent };